var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { prop: "analysis_name" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("解析器名称")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "analysis_name" },
                    model: {
                      value: _vm.ruleForm.analysis_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "analysis_name", $$v)
                      },
                      expression: "ruleForm.analysis_name",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "open_status" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("开关状态")]),
                  ]),
                  _c("v-radio", {
                    staticClass: "options",
                    attrs: { name: "open_status", options: _vm.statusOptions },
                    model: {
                      value: _vm.ruleForm.open_status,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "open_status", $$v)
                      },
                      expression: "ruleForm.open_status",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "source_id" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("数据源")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "source_id",
                      name: "source_id",
                      placeholder:
                        _vm.sourceIdOptins.length > 0
                          ? "请选择"
                          : "请先新建数据源",
                      options: _vm.sourceIdOptins,
                    },
                    model: {
                      value: _vm.ruleForm.source_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "source_id", $$v)
                      },
                      expression: "ruleForm.source_id",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "dest_id" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("数据目的")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "dest_id",
                      name: "dest_id",
                      placeholder:
                        _vm.destIdOptins.length > 0
                          ? "请选择"
                          : "请先新建数据目的",
                      options: _vm.destIdOptins,
                    },
                    model: {
                      value: _vm.ruleForm.dest_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "dest_id", $$v)
                      },
                      expression: "ruleForm.dest_id",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "analysis_desc" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("描述")]),
                  ]),
                  _c("v-input", {
                    staticClass: "remarks",
                    attrs: {
                      type: "textarea",
                      name: "analysis_desc",
                      maxlength: 200,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.analysis_desc,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "analysis_desc", $$v)
                      },
                      expression: "ruleForm.analysis_desc",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }